import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketFolderViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TICKET_FOLDER_VIEW = '/api/ticket-folder-view';
        this.GET_LIST_BY_RESOLVE_ID = '/get/{kaiziqResolveConnectionId}';
        this.GET_LIST_BY_RESOLVE_ID_AND_EXPORTS_FILES = '/get-files-with-exports/{kaiziqResolveConnectionId}';
    }

    async getListByResolveConnectionId(kaiziqResolveConnectionId) {
        try {
            let url = window.location.origin + this.TICKET_FOLDER_VIEW + this.GET_LIST_BY_RESOLVE_ID;
            url = url
                .replace('{kaiziqResolveConnectionId}', kaiziqResolveConnectionId);
            const list = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return list;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketFolderListWithExports(kaiziqResolveConnectionId) {
        try {
            let url = window.location.origin + this.TICKET_FOLDER_VIEW + this.GET_LIST_BY_RESOLVE_ID_AND_EXPORTS_FILES;
            url = url
                .replace('{kaiziqResolveConnectionId}', kaiziqResolveConnectionId);
            const list = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return list;
        } catch (err) {
            console.log(err);
        }
    }
}

export default TicketFolderViewService;
